.button {
    width: 100%;
    justify-content: space-between;
    color: white;
    border-radius: var(--mantine-radius-md);
    transition: background-color 0.15s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
}

.button:hover .section,
.button.expanded .section,
.button.streaming .section {
    width: auto;
    overflow: hidden;
    opacity: 1;
}

.section {
    @container (min-width: $mantine-breakpoint-sm) {
        width: 0;
        opacity: 0;
        margin-left: 0;
    }
}

.button {
    @container (min-width: $mantine-breakpoint-sm) {
        &:hover section,
        &.expanded section {
            width: auto;
            overflow: hidden;
            opacity: 1;
        }
    }
}

.expanded {
    background-color: rgba(255, 255, 255, 0.15);
}

.label {
    width: 100%;
    background: linear-gradient(to right, white 80%, transparent 100%);
    background-clip: text;
    color: transparent;
}

.selected {
    background-color: rgba(255, 255, 255, 0.15);
}

.loading {
    background: rgba(255, 255, 255, 0.05);
    animation: pulse 3s linear infinite;
}

@keyframes pulse {
    0%,
    100% {
        background-color: rgba(255, 255, 255, 0.05);
    }
    50% {
        background-color: rgba(255, 255, 255, 0.15);
    }
}
